<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Sesión: Accesos</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">FechaReg</th>
          <th scope="col">SesionFechaReg</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="accesosesion in datosPaginados" :key="accesosesion.idAccesoSesion">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(accesosesion.idAccesoSesion)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(accesosesion.idAccesoSesion)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(accesosesion.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(accesosesion.sesionFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAccesoSesion(accesosesion.idAccesoSesion)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAccesoSesion" class="form-label">IdAccesoSesion</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAccesoSesion" name="idAccesoSesion" v-model="datoAccesoSesion.idAccesoSesion" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Modu Usua -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idModuUsua" class="form-label"> Modu Usua</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idModuUsua" name="idModuUsua" v-model="datoAccesoSesion.idModuUsua">
                      <option v-for="moduUsua in moduUsuas" :value="moduUsua.idModuUsua" :key="moduUsua.idModuUsua">
                        {{ moduUsua.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Modu Usua -->
<!-- Botón Lista de Valores  Sesion -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idSesion" class="form-label"> Sesion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idSesion" name="idSesion" v-model="datoAccesoSesion.idSesion">
                      <option v-for="sesion in sesions" :value="sesion.idSesion" :key="sesion.idSesion">
                        {{ sesion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Sesion -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoAccesoSesion.fechaReg" disabled>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarAccesoSesion" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAccesoSesion" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      accesosesions : [],
      datoAccesoSesion : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      moduUsuas: [],
      sesions: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchModuUsuas()
    this.fetchSesions()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.accesosesions.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwaccesosesions/nombre/'+this.nombreBusqueda).then(response=>{
          this.accesosesions=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.accesosesions.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwaccesosesions').then(response=>{
      this.accesosesions=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.accesosesions.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idModuUsua'
        ,'idSesion'
      ];
      const requiredFieldsText = [
        'idModuUsua'
        ,'idSesion'
      ];
      return validarForm(this.datoAccesoSesion, requiredFields, requiredFieldsText);
    },
    async guardarAccesoSesion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/accesosesions', this.datoAccesoSesion)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AccesoSesion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAccesoSesion(){
      if(this.validarForm() === 1){
        try {
          await api.post('/accesosesions', this.datoAccesoSesion)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AccesoSesion creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAccesoSesion={}
      this.titulo   = 'Crear Sesión: Accesos'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idAccesoSesion){
      this.modalWindow = true
      if(idAccesoSesion != null){    
           api.get('/vwaccesosesions/'+idAccesoSesion).then(resp=>{
          this.datoAccesoSesion = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Sesión: Accesos'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idAccesoSesion){
      if(idAccesoSesion != null){
        this.$router.push('/accesosesionmd/'+idAccesoSesion)
      }
    },
    async deleteAccesoSesion (idAccesoSesion) {
      try{
        await api.delete('/accesosesions/'+idAccesoSesion)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchModuUsuas() {
      fetch('http://localhost:8080/api/v1/moduusuas')
        .then(response => response.json())
        .then(data => {
          this.moduUsuas = data;
        })
        .catch(error => {
          console.error('Error fetching moduUsuas:', error);
        });
    },
    fetchSesions() {
      fetch('http://localhost:8080/api/v1/sesions')
        .then(response => response.json())
        .then(data => {
          this.sesions = data;
        })
        .catch(error => {
          console.error('Error fetching sesions:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
